import React from 'react';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import AddIcon from '@mui/icons-material/Add';
import { Avatar, Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import useStore from '../../../Store/Store';
import { isEmpty, map } from 'lodash';
import moment from 'moment';
import {
  getRecipientTodayMedications,
  getTodayMedications,
  updateRecipientTodayMedications,
  updateTodayMedications,
} from '../../../utils/api';
import { MEDICATION_STATUS } from '../../../constants';
import { useTranslation } from 'react-i18next';
import DashboardCard from './DashboardCard';

const PillReminderCard = () => {
  const { t } = useTranslation();
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const selectedRecipient = useStore((state) => state.selectedRecipient);

  const { data, isLoading, refetch } = useQuery(
    ['getTodayMeds', 'getRecipientTodayMeds', selectedRecipient],
    () =>
      isEmpty(selectedRecipient)
        ? getTodayMedications({ userId: user?._id || user?.id })
        : getRecipientTodayMedications({
            userId: user?._id || user?.id,
            selectedRecipient: selectedRecipient,
          }),
    { retry: false, cacheTime: 0 },
  );

  const updateTodayMeds = useMutation(updateTodayMedications, {
    onSuccess: () => setTimeout(refetch, 300),
  });

  const updateRecipientTodayMeds = useMutation(updateRecipientTodayMedications, {
    onSuccess: () => setTimeout(refetch, 300),
  });

  const handleClickMeds = (eventId, status) => {
    const userId = user?._id || user?.id || '';

    if (!isEmpty(selectedRecipient)) {
      updateRecipientTodayMeds.mutate({ userId, selectedRecipient, eventId, status });
    } else {
      updateTodayMeds.mutate({ userId, eventId, status });
    }
  };

  if (isLoading) {
    return (
      <DashboardCard>
        <Skeleton animation="wave" height="100%" width="100%" />
      </DashboardCard>
    );
  }

  return (
    <DashboardCard>
      {/* Card Header */}
      <div className="pill-reminder-header" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <span className="pill-reminder-7c">{t('pillReminder')}</span>
        <div className="button-7d">
          <div className="arrow-up-right-7e" onClick={() => history('/medications')} style={{ cursor: 'pointer' }}>
            <ArrowOutwardIcon fontSize="14px" />
          </div>
        </div>
      </div>

      {/* Card Content */}
      <div className="frame-80">
        {isEmpty(data?.data) ? (
          <>
            <div className="empty-data">{t('thereIsNoData')}</div>
            <button
              className="button-8f"
              style={{ width: '180px', alignSelf: 'center' }}
              onClick={() => history('/medications?addMeds=1')}
            >
              <AddIcon style={{ fontSize: '17px', color: '#fff' }} />
              <span style={{ color: '#fff' }}>{t('addMedications')}</span>
            </button>
          </>
        ) : (
          map(data?.data, (item, idx) => (
            <div className="pill-reminder-81" key={idx}>
              <div className="frame-82">
                <div
                  className="frame-83"
                  style={{
                    backgroundColor: `light${item?.medicationData?.color}`,
                  }}
                >
                  <div className="pill-84">
                    <div className="empty-85">
                      <SportsBaseballIcon fontSize="20" style={{ color: item?.medicationData?.color }} />
                    </div>
                  </div>
                  <div className="avatars-87">
                    <Avatar style={{ width: '15px', height: '15px' }} />
                  </div>
                </div>

                <div className="frame-89">
                  <div className="frame-8a">
                    <span className="lisinopril">{item?.title || ''}</span>
                    <button className="tags-8b">
                      <span className="label-8c">{moment.unix(item?.start).format('hh:mm a')}</span>
                    </button>
                  </div>
                  <div className="frame-8d">
                    <span className="capsule">
                      {item?.medicationData?.quantity || 1} {item?.medicationData?.type || ''}
                    </span>
                    <div className="ellipse" />
                    <span className="with-meal">{item?.medicationData?.howToTake || ''}</span>
                  </div>
                </div>
              </div>

              {/* Status Buttons */}
              {item?.status === MEDICATION_STATUS.pending && (
                <div className="frame-8e">
                  <button className="button-8f" onClick={() => handleClickMeds(item?._id, MEDICATION_STATUS.completed)}>
                    <span className="button-90">Take</span>
                  </button>
                  <button className="button-91" onClick={() => handleClickMeds(item?._id, MEDICATION_STATUS.cancelled)}>
                    <span className="button-92">Skip</span>
                  </button>
                </div>
              )}

              {item?.status === MEDICATION_STATUS.completed && (
                <div className="frame-b7">
                  <div className="tags-b8">
                    <span className="label-b9">Taken</span>
                  </div>
                </div>
              )}

              {item?.status === MEDICATION_STATUS.cancelled && (
                <div className="frame-b7">
                  <div className="tags-b8">
                    <span className="label-b9">Skipped</span>
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </DashboardCard>
  );
};

export default PillReminderCard;
